"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createKubernetesCluster = void 0;
const createKubernetesCluster = ({ httpClient, }) => ({ name, region, version, tags, auto_upgrade, maintenance_policy, node_pools, vpc_uuid, }) => {
    const path = '/kubernetes/clusters';
    const body = {
        name,
        region,
        version,
        tags,
        auto_upgrade,
        maintenance_policy,
        node_pools,
        vpc_uuid,
    };
    const url = `${path}`;
    return httpClient.post(url, body);
};
exports.createKubernetesCluster = createKubernetesCluster;
//# sourceMappingURL=create-kubernetes-cluster.js.map